
import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Mail } from 'lucide-react';

interface ShareDialogProps {
  showShareDialog: boolean;
  setShowShareDialog: (show: boolean) => void;
  shareEmail: string;
  setShareEmail: (email: string) => void;
  handleShareByEmail: () => void;
}

const ShareDialog = ({
  showShareDialog,
  setShowShareDialog,
  shareEmail,
  setShareEmail,
  handleShareByEmail
}: ShareDialogProps) => {
  return (
    <Dialog open={showShareDialog} onOpenChange={setShowShareDialog}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Share Assessment</DialogTitle>
        </DialogHeader>
        
        <div className="space-y-4 py-4">
          <p className="text-sm text-muted-foreground">
            Enter an email address to share this assessment with a colleague.
          </p>
          
          <Input
            placeholder="colleague@company.com"
            value={shareEmail}
            onChange={(e) => setShareEmail(e.target.value)}
          />
          
          <Button 
            variant="purple" 
            className="w-full"
            onClick={handleShareByEmail}
          >
            <Mail size={16} className="mr-2" /> Send
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ShareDialog;
